/**
 * Sanitize a stored table sort into TanStack SortingState.
 *
 * Accepts a single `{ id, desc }` entry or an array of them (only the first
 * entry is kept — ClientDataTable sorts by one column at a time). Anything
 * malformed collapses to `[]` (unsorted).
 */
export function sanitizeTableSorting(value) {
  const entry = Array.isArray(value) ? value[0] : value;
  if (!entry || typeof entry !== 'object') return [];
  if (typeof entry.id !== 'string' || !entry.id) return [];
  return [{ id: entry.id, desc: entry.desc === true }];
}
